import { render } from "./fourteen-testimonial.vue?vue&type=template&id=75aa1297"
import script from "./fourteen-testimonial.vue?vue&type=script&lang=js"
export * from "./fourteen-testimonial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__